// extracted by mini-css-extract-plugin
export var title = "index-module--title--dmrol";
export var video = "index-module--video--DYwQS";
export var view = "index-module--view--U6ylC";